module.exports = __webpack_public_path__ + "static/img/border-2.2b94b09d.png";